import { render, staticRenderFns } from "./commande_a_traiter_detail.vue?vue&type=template&id=79e874fc&scoped=true&"
import script from "./commande_a_traiter_detail.vue?vue&type=script&lang=js&"
export * from "./commande_a_traiter_detail.vue?vue&type=script&lang=js&"
import style0 from "./commande_a_traiter_detail.vue?vue&type=style&index=0&id=79e874fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e874fc",
  null
  
)

export default component.exports